import useToken from 'hooks/useToken';

/**
 * Custom hook para manejar notificaciones
 */
const useOrdenNotificaciones = () => {
    const { token } = useToken();

    /**
     * Crea un objeto de acción para notificaciones
     */
    const crearObjAction = (TypeAction, vURL, idModalType, idLead) => {
        const objToAction = {
            TypeAction: TypeAction,
            detalles: {
                vUrl: vURL,
                idModalType: idModalType,
                data: {
                    idLead: idLead
                }
            }
        };

        const objToActionString = JSON.stringify(objToAction);
        console.log("objToAction de la Orden: ", objToActionString);
        return objToActionString;
    };

    /**
     * Guarda una notificación
     */
    const guardarNotificacion = async (
        vTitulo,
        vCuerpo,
        idUsuarioTarget,
        objToAction,
        idTipoNotificacion,
        jsonData = null,
        onSuccess,
        onError
    ) => {
        const jDataSend = {
            vTitulo,
            vCuerpo,
            idUsuarioTarget,
            objToAction,
            idTipoNotificacion,
            jsonData
        };

        console.log("jDataSend: ", jDataSend);

        try {
            const response = await fetch("/api/leads/guardarNotificacion/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (response.ok) {
                console.log("==== NOTIFICACIÓN GUARDADA ====");
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const detalles = JSON.parse(data.detalles);
                    const notificacionesList = detalles.table2;

                    // Enviar notificaciones push
                    notificacionesList.forEach((objNotify) => {
                        sendPushNotificationRealTime(objNotify.vToken, objNotify.vCuerpo);
                    });

                    onSuccess?.();
                } else {
                    onError?.(data.vMessage);
                }
            } else {
                onError?.(response.status + ' ' + response.statusText);
            }
        } catch (error) {
            console.log('Hubo un problema con la peticion Fetch:' + error);
            onError?.('Hubo un problema con la peticion Fetch: ' + error);
        }
    };

    /**
     * Envía una notificación push en tiempo real
     */
    const sendPushNotificationRealTime = async (vToken, vNotificacion) => {
        try {
            const responseTokenFCM = await fetch("/api/account/generateToken/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (responseTokenFCM.ok) {
                const dataFCM = await responseTokenFCM.json();
                const tokenFCM = dataFCM.detalles;

                const response = await fetch('https://fcm.googleapis.com/v1/projects/akasia-admin-panel/messages:send', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + tokenFCM,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        message: {
                            token: vToken,
                            data: { vNotificacion: vNotificacion }
                        }
                    })
                });

                const dataNtf = await response.json();
                console.log('Notificación enviada:', dataNtf);
            }
        } catch (error) {
            console.error('Error al enviar la notificación:', error.message);
        }
    };

    return {
        crearObjAction,
        guardarNotificacion,
        sendPushNotificationRealTime
    };
};

export default useOrdenNotificaciones;
